import dotProp from "dot-prop-immutable"

import { MDB_TYPES } from "@meddbriefer/scenario-data/constants.js";


const computeDepth = (item) => {
  let depth = item.depth
  if (!!item.subPhase) {
    depth += 1
  }
  return `${depth * 20}px`
}

const ScenarioItem = ({item, scenario, changeHandler}) => {

  switch (item.type) {
        case MDB_TYPES.PHASE:
          return (
            <h2 className="list-item header-item">
              {item.label}
            </h2>
          )
        case MDB_TYPES.SUB_PHASE:
          return (
            <h3 className="list-item header-item" style={{paddingLeft: "20px"}}>
              {item.label}
            </h3>
          )
        case MDB_TYPES.CL_HEADING:
          return (
            <h4 className="list-item header-item" style={{paddingLeft: `${computeDepth(item)}`}}>
              {item.label}
            </h4>
          )
        default:
          return (
            <label style={{paddingLeft: `${computeDepth(item)}`}}>
              {item.abbrLabel}: &nbsp;
              <input
                type="text"
                id={`assessmentFindings.${item.id}`}
                size="80"
                value={dotProp.get(scenario, `assessmentFindings.${item.id}`)}
                onChange={changeHandler}
              />
            </label>
          )
      }
}

export default ScenarioItem;
